<template>
    <div style="width: 100%; height: 100%;">
        <campaign-popup v-if="popup" @onDelete='campaignDeleted' @closePopup="hidePopup" :campaignID="campaignID"></campaign-popup>
        <div class="dashboard__container" v-if="!popup">
            <side-menu-header :role="store.state.user.role"></side-menu-header>
            <div class="dashboard__header">
                <h1>All campaigns</h1>
                <div class="list__controls">
                    <svg width="26" height="28" viewBox="0 0 26 28" fill="none" xmlns="http://www.w3.org/2000/svg" :class="{'active-control': listType=='list'}" @click="listType='list'">
                        <path d="M25 0H1C0.447715 0 0 0.447715 0 1V5C0 5.55228 0.447715 6 1 6H25C25.5523 6 26 5.55228 26 5V1C26 0.447715 25.5523 0 25 0Z"/>
                        <path d="M25 11H1C0.447715 11 0 11.4477 0 12V16C0 16.5523 0.447715 17 1 17H25C25.5523 17 26 16.5523 26 16V12C26 11.4477 25.5523 11 25 11Z"/>
                        <path d="M25 22H1C0.447715 22 0 22.4477 0 23V27C0 27.5523 0.447715 28 1 28H25C25.5523 28 26 27.5523 26 27V23C26 22.4477 25.5523 22 25 22Z"/>
                    </svg>
                    <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg" :class="{'active-control': listType=='box'}" @click="listType='box'">
                        <path d="M12 0H1C0.447715 0 0 0.447715 0 1V12C0 12.5523 0.447715 13 1 13H12C12.5523 13 13 12.5523 13 12V1C13 0.447715 12.5523 0 12 0Z"/>
                        <path d="M28 0H17C16.4477 0 16 0.447715 16 1V12C16 12.5523 16.4477 13 17 13H28C28.5523 13 29 12.5523 29 12V1C29 0.447715 28.5523 0 28 0Z"/>
                        <path d="M12 16H1C0.447715 16 0 16.4477 0 17V28C0 28.5523 0.447715 29 1 29H12C12.5523 29 13 28.5523 13 28V17C13 16.4477 12.5523 16 12 16Z"/>
                        <path d="M28 16H17C16.4477 16 16 16.4477 16 17V28C16 28.5523 16.4477 29 17 29H28C28.5523 29 29 28.5523 29 28V17C29 16.4477 28.5523 16 28 16Z"/>
                    </svg>
                </div>
            </div>
            <div class="dashboard__body">
                <div class="dashboard__boxes" v-if="campaigns && campaigns.length > 0 && listType=='box'">
                    <div class="campaign__container" v-for="campaign in campaigns" @click="openPopup(campaign.id)" v-bind:key="campaign.id">
                        <div class="campaign__status__point" :class="[campaign.status === 'approved' ? campaign.active === 'N' ? 'inactive__status' : 'approved__status' : campaign.status + '__status']"></div>
                        <div class="campaign__pair">
                            <p class="label">CAMPAIGN</p>
                            <p class="value campaign__value">{{ campaign.name }}</p>
                        </div>
                        <div class="campaign__pair">
                            <p class="label">ADVERTISER</p>
                            <p class="value advertiser__value">{{ campaign.advertiser }}</p>
                        </div>
                        <div class="campaign__pair">
                            <p class="label">
                           CAMPAIGN ID
                            </p>
                            <p class="value campaignid__value">{{ campaign.id }}</p>
                        </div>
                        <!-- <div class="campaign__status" :class="campaign.status + '__status'">
                            <p>{{ campaign.status.toUpperCase() }}</p>
                        </div> -->
                    </div>
                </div>
                <div class="dashboard__list" v-if="campaigns && campaigns.length > 0 && listType=='list'">
                    <div class="dashboard__list__container">
                    <table style="width: 100%">
                        <tr>
                            <th class="campaign__header"><span>CAMPAIGN</span></th>
                            <th class="advertiser__header" v-if="user.role !== 'advertiser'"><span>ADVERTISER
                              <div @click="sort(1)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div></span>
                            </th>
                            <th class="campaignid__header"><span>CAMPAIGN ID
                              <div @click="sort(0)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div></span></th>
                            <th class="status__header"><span>STATUS
                              <div @click="sort(8)">
                                        <img src="./../../assets/sort_up.svg" alt="up" class="sort__image sort__up">
                                        <img src="./../../assets/sort_down.svg" alt="down" class="sort__image">
                                    </div></span></th>
                        </tr>
                          <tr v-for="campaign in paginationCampaigns" v-bind:key="campaign.id" class="table__data" @click="openPopup(campaign.id)">

                            <td class="table__data">{{campaign.name}}</td>
                            <td class="_advertiser table__data" v-if="user.role !== 'advertiser'">{{campaign.advertiser}}</td>
                            <td class="table__data">{{campaign.id}}</td>
                            <td class="status__value table__data">
                                <div v-bind:class="[campaign.status === 'approved' ? campaign.active === 'N' ? 'inactive__status' : 'approved__status' : campaign.status + '__status']" style="width: 16px; height: 16px; border-radius: 15px;"></div>
                            </td>
                        </tr>
                    </table>
                      <paginate
                        v-if="campaigns.length > 0"
                        v-model="campaignNumber"
                        :page-count="campaignTotal"
                        :container-class="'paginationContainer'"
                        :active-class="'paginationActive'"
                        :click-handler="campaignPaggination">
                    </paginate>


                    </div>
                      <div class="activate_buttons">
                        <button @click="activate_campaigns" class="btn__activate">ACTIVATE ALL</button>
                        <button @click="deactivate_campaigns" class="btn__deactivate">DEACTIVATE ALL</button>

                    </div>
                </div>

                <div class='no__results' v-if="campaigns && campaigns.length === 0">
                    <p>We're sorry, no campaigns were found.</p>
                    <p @click="openCreate" class="create-btn">Create one now !!</p>
                </div>
                <Loading v-if="campaigns===null" />
            </div>
        </div>
    </div>
</template>
<script>
import toast from '@utils/toast.js'
import SideMenuHeader from './../design/SideMenuHeader.vue'
import CampaignPopup from '@partials/CampaignPopup.vue'
import { mapGetters } from 'vuex'
import store from '@store'
import Loading from '@partials/Loading'
import config from '../../plugins/utils/Config'
import { paginateList, paginationTotal } from '@utils/pagination.js'
export default {
    name: 'Dashboard',
    data () {
        return {
            listType: 'list', // Can be "list" as well
            campaigns: null,
            activeCampaign: {},
            activeCampaignReport: {},
            activeCampaignStats: {},
            store: store,
            sorts: [false, false, false, false, false, false, false, false,false],
             campaignNumber: 1,
            campaignTotal: 1,
        }
    },
    components: {
        CampaignPopup,
        SideMenuHeader,
        Loading
    },
    methods: {
        openPopup (campaignID) {
            this.store.commit('setPopup', true)
            this.campaignID = campaignID
            document.getElementById("app").scrollTop = 0;
        },
        hidePopup () {
            this.store.commit('setPopup', false)
            this.getCampaigns()
        },
        getCampaigns () {
            var url = '/get/campaign/list'
            this.request(url, 'POST', {}).then(response=>{
                if (response.code === 0) {
                    this.campaigns = response.data

                    this.setTotalPagginationLength()
                } else {
                    if (response.code === 112) {
                        this.checkTokenConditions(this.getCampaigns)
                    }
                }
            })
        },
        campaignDeleted () {
            this.hidePopup()
            this.getCampaigns()
        },
        openCreate () {
            this.$router.push({name: 'CreateCampaign'})
        },
        sort (value) {
            this.sorts[value] = !this.sorts[value]
            if (this.sorts[value]) {
                toast.simpleMessage('Sort type: Ascending')
            } else {
                toast.simpleMessage('Sort type: Descending')
            }
           this.campaigns.sort((a, b) => {
               if(b[Object.keys(b)[value]] === null || b[Object.keys(b)[value]]=="")  return -1;
               if(a[Object.keys(a)[value]] === null || a[Object.keys(a)[value]]=="")  return 1;
               let lowerCaseA=a[Object.keys(a)[value]];
               let lowerCaseB=b[Object.keys(b)[value]];
               if(!isNaN(lowerCaseA) && !isNaN(lowerCaseB)){
                lowerCaseA=parseInt(lowerCaseA);
                lowerCaseB=parseInt(lowerCaseB);
              }else{
                lowerCaseA=lowerCaseA.toString().toLowerCase();
                lowerCaseB=lowerCaseB.toString().toLowerCase();
              }
                return lowerCaseB < lowerCaseA ? !this.sorts[value] ? -1 : 1
                : lowerCaseB > lowerCaseA ? this.sorts[value] ? -1 : 1
                : 0
            })
        },
         campaignPaggination (number) {
            this.campaignNumber = number
        },
        setTotalPagginationLength () {
            this.campaignTotal = paginationTotal(this.campaigns.length,5)
        },

        activate_campaigns (){

            var url = '/bulk/campaign'
             var body = {
                  API_KEY: this.store.getters.keys.api_key,
                  code: this.token.token,
                  user: this.user.user,
                  data: {
                     "action": "activate"
                  }
            }
            this.request(url, 'POST', body).then(response=>{
                if (response.code === 0) {
                    this.getCampaigns()
                 } else {
                    toast.errorMessage(response.message)
                    if (response.code === 112) {
                        this.checkTokenConditions(this.activate_campaigns)
                    }
                }
            }).catch(error => {
                toast.errorMessage(response.message)
            })

        },
        deactivate_campaigns (){
            var url = '/bulk/campaign'
             var body = {
                  API_KEY: this.store.getters.keys.api_key,
                  code: this.token.token,
                  user: this.user.user,
                  data: {
                     "action": "deactivate"
                  }
            }


            this.request(url, 'POST', body).then(response=>{
                if (response.code === 0) {
                    // this.campaigns.filter(function (campaign) {
                    //     return campaign['status'] = true
                    // })
                    this.getCampaigns()
                 } else {
                    toast.errorMessage(response.message)
                    if (response.code === 112) {
                        this.checkTokenConditions(this.deactivate_campaigns)
                    }
                }
            }).catch(error => {
                toast.errorMessage(response.message)
            })

        },
        checkTokenConditions (callback) {
            try{
                var expiresDate = new Date(this.token.expires)
            } catch (err) {
                this.$router.push('/login')
            }
            var now = new Date()
            if (expiresDate <= now) {
                this.store.commit('setToken', {})
                this.$router.push('/login')
            } else {
                var body = {
                code: '',
                refresh_token: this.token.refresh_token
                }
                this.request('/refresh/token', 'POST', body).then((response) => {
                if (response.code === 0 ) {
                    this.store.commit('setToken', response.data[0])
                    this.store.commit('setDriver', response.data[0].driver)
                    callback()
                } else if (response.code === 112) {
                    this.store.commit('setToken', {})
                    this.$router.push('/login')
                }
                }).catch((error) => {
                })
            }
            var token = this.token
            token.redirect = false
            this.store.commit('setToken', token)
        }
    },
    mounted() {
        this.getCampaigns()
    },
    computed: {
        ...mapGetters({
            user: 'getUser',
            popup: 'getPopup',
            token: 'getToken'
        }),
          paginationCampaigns: function () {
        return paginateList(this.campaigns, this.campaignNumber, 5)
      }
    }
}
</script>
<style scoped>
.dashboard__container{
    width: 100%;
    position: relative;
    box-sizing: border-box;
    padding: 20px;
    text-align: left;
    display: flex;
    flex-direction: column;
}
.dashboard__header{
    width: 100%;
    display: flex;
    flex-direction: column;
}
.dashboard__header h1{
    font-size: 36px;
    font-weight: normal !important;
    margin: 0;
    padding: 0;
}
.dashboard__header .list__controls{
    text-align: right;
    margin-bottom: 15px;
}
.dashboard__header .list__controls svg{
    margin: 5px;
    cursor: pointer;
}
.dashboard__header .list__controls path{
    fill: #C4CBD9;
}
.dashboard__header .list__controls .active-control path{
    fill: #848EA3;
}
.dashboard__body{
    flex-grow: 1;
    position: relative;
}
.dashboard__boxes{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}
.campaign__container{
    width: 250px;
    border-radius: 5px;
    box-shadow: 0px 0px 27px rgba(15, 32, 47, 0.5);
    padding: 15px;
    background: #fff;
    position: relative;
    cursor: pointer;
    margin-right: 35px;
    margin-bottom: 35px;
}
.campaign__container .label{
    font-size: 12px;
    color: #777777;
    margin: 15px 0 0 0;
    padding: 0;
}
.campaign__container .value{
    color: #2E2E2E;
    margin: 0;
    padding: 0;
    font-weight: 500;
}
.campaign__container .campaign__value{
    font-size: 20px;
}
.campaign__container .advertiser__value{
    font-size: 18px;
}
.campaign__container .campaignid__value{
    font-size: 16px;
}
.campaign__status{
    float: right;
    height: 12px;
    border-radius: 12px;
    background: #DD4242;
    color: #fff;
    padding: 5px 15px 5px 15px;
    display: flex;
    align-items: center;
}
.campaign__status p{
    margin: 0;
    padding: 0;
    font-size: 12px;
}
.campaign__status__point{
    width: 16px;
    height: 16px;
    background: #DD4242;
    position: absolute;
    top: 10px;
    right: 10px;
    border-radius: 50px;
}
.dashboard__list{
    width: 100%;
    margin-top: 15px;
}
.dashboard__list__container{
    width: 100%;
}
.dashboard__list .list__header{
    display: flex;
    margin-top: 15px;
    margin-bottom: 5px;
    padding: 10px 0 10px 15px;
}
.dashboard__list .list{
}
.dashboard__list .list .campaign__item{
    background: #FAFAFC;
    display: flex;
    margin: 5px 0 5px 0;
    padding: 10px 0 10px 15px;
    border-radius: 5px;
    cursor: pointer;
}
.dashboard__list .list__header p, .dashboard__list .list .campaign__item p{
    padding: 0;
    margin: 0;
    text-align: left;
}
.dashboard__list .list .campaign__item div p{
    margin: 0;
    padding: 0;
}
.dashboard__list .list__header .campaign__header, .dashboard__list .list .campaign__item .campaign{
    width: 40%;
}
/*.dashboard__list .list__header .active__header, .dashboard__list .list .campaign__item .active{
    width: 15%;
}*/
.dashboard__list .list__header .advertiser__header, .dashboard__list .list .campaign__item ._advertiser{
    width: 30%;
}
.dashboard__list .list__header .campaignid__header, .dashboard__list .list .campaign__item .campaignid{
    min-width: 20%;
    flex-grow: 1;
    text-align: center;
}
.dashboard__list .list .campaign__item .campaignid p{
    text-align: center;
}
.dashboard__list .list__header .status__header, .dashboard__list .list .campaign__item .status{
    width: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.dashboard__list .list .campaign__item .active p{
    background: #DD4242;
    color: #fff;
    border-radius: 15px;
    padding: 0 10px 0 10px;
    display: inline-block;
}
.dashboard__list .list .campaign__item .status p{
    width: 12px;
    height: 12px;
    background: #DD4242;
    border-radius: 50%;
}
.no__results p{
    margin: 5px;
    padding: 0;
}
.no__results .create-btn{
    color: #2EA3FF;
    cursor: pointer;
}
.activate_buttons {
    float:right;
}
.activate_buttons button{
    font-style: normal;
    height: 34px;
    font-size: 13px;
    border-radius: 5px;
     margin-left:30px;
      margin-bottom:20px;
}
.btn__deactivate{
    background: #FA3C3E;
    color: #FFFFFF;
    border: 2px solid #FA3C3E;
}
.btn__activate{
    background: #6DE0B6;
    color: #000000;
    border: 2px solid #6DE0B6;
}
table{
    border-collapse: separate !important;
    border-spacing: 0 8px;
    border-style: hidden;
}
td{
        border: solid 1px transparent;
    background: rgba(235, 234, 244, 0.25);
}
th div{
    /*display: inline-block;
    */
    position: relative;
    display: inline-grid;
    float: right;
    height: 17px;
     margin-left: 5px;
}
.table__data {
    height: 50px;
    }
th span{
     display: flex;
    white-space: nowrap;
}
.sort__image{
    widows: 17px;
    height: 7px;
    margin: 0 5px;
    cursor: pointer;
}
@media only screen and (max-width: 600px) {
    .dashboard__header{
        flex-direction: row;
        justify-content: space-between;
        margin-top: 10px;
    }
    .dashboard__header h1{
        font-size: 24px;
    }
    .dashboard__list, .dashboard__list__container{
        margin-left: 0 !important;
    }
    .dashboard__header .list__controls svg{
        width: 20px;
        height: 20px;
    }
    .dashboard__list .list__header .campaign__header, .dashboard__list .list .campaign__item .campaign{
        width: 40%;
        font-size: 12px;
    }
    .dashboard__list .list__header .active__header, .dashboard__list .list .campaign__item .active{
        display: none;
    }
    .dashboard__list .list__header .campaignid__header, .dashboard__list .list .campaign__item .campaignid{
        width: 30%;
        font-size: 12px;
    }
    .dashboard__list .list__header .status__header, .dashboard__list .list .campaign__item .status{
        width: 30%;
        font-size: 12px;
    }
    .dashboard__boxes{
        margin-top: 25px;
    }
    .campaign__container{
        width: 80%;
        margin-left:auto;
        margin-right: auto;
        box-shadow: 0 0 10px rgba(15, 32, 47, .5);
        margin-bottom: 20px;
    }
    .campaign__container .campaign__pair .label, .campaign__container .campaign__pair .value{
        font-size: 12px;
    }
    .activate_buttons{
            display: flex;
    margin-top: 15px;
    }
    .activate_buttons button:first-child{
        margin-left: 0;
    }
    .btn__deactivate{
        margin-right: 5px;
    }
    th{
        width: 25% !important;
        font-size: 80%;
    }
    th span{
        font-size: 80%;
        display:inline-flex;
        line-height: 16px;
    }
}

@media only screen and (max-width: 1000px){
    .dashboard__list__container{
        overflow-x:auto;
    }
}
@media only screen and (min-width: 600px) and (max-width: 1024px) {
     th{
        width: 25% !important;
    }

}

</style>
